export { SetLocaleCTA } from './SetLocaleCTA';
